<template>
  <a-spin :spinning="spinner">
    <div class="w-full relative">
      <TotalComplaints :total="count" title="Total conciliaciones y demandas" body="solicitudes registradas" />
      <header class="
        mb-4
        flex flex-col-reverse
        items-center
        justify-center
        lg:flex-row lg:justify-between
        gap-3
      ">
        <div class="w-full md:max-w-sm grid grid-cols-1 lg:grid-cols-2 gap-4">
          <a-button type="primary" shape="round" :block="true" class="w-56" @click="modal2Visible = true">
            <span class="flex items-center justify-center font-sans text-xs">
              <b>Cargar archivo de SOLIP</b>
              <a-icon type="pic-center" :style="{ fontSize: '10px' }" class="ml-4" />
            </span>
          </a-button>
        </div>
        <div class="w-full sm:max-w-sm">
          <label for="table-search" class="sr-only">Search</label>
          <div class="relative">
            <div class="
              flex
              absolute
              inset-y-0
              left-0
              items-center
              pl-3
              pointer-events-none
            ">
              <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"></path>
              </svg>
            </div>
            <a-input-search placeholder="Buscar un usuario en particular" class="rounded-full" style="width: 100%"
              @search="onSearch" v-model="filterSearch" />
          </div>
        </div>
      </header>
      <div v-if="step === 1" class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints">
        <a-table :columns="columns" rowKey="code" :data-source="dataRows" :pagination="false" :scroll="{ x: '1220px' }">
          <div slot="name" class="title-size font-bold text-gray-500 text-center ">
            <p>Nombre del CF</p>
          </div>
          <div slot="entity" class="title-size font-bold text-gray-500">
            Entidad
          </div>
          <div slot="solicitude" class="title-size font-bold text-gray-500">
            Solicitud
          </div>
          <div slot="status" class="title-size font-bold text-gray-500">
            Estado
          </div>
          <div slot="status" slot-scope="text, record" class="flex flex-row">
            <p class="w-full rounded-full text-center"
              :class="record.status == 'Abierto' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'">
              {{ record.status }}
            </p>

          </div>
          <div slot="code" class="flex flex-row justify-items-center title-size font-bold text-gray-500">
            Código interno
          </div>
          <div slot="codeSOLIP"
            class="grid items-center content-center items-center text-center title-size font-bold text-gray-500">
            Código SOLIP
          </div>
          <div slot="codeSOLIP" slot-scope="text, record" class="flex flex-row">
            <a-input placeholder="Ingresar código" v-model="record.codeSOLIP" :disabled="record.hasSolipCode"
              class="rounded-full w-full" />
            <button v-if="record.hasSolipCode" class="flex justify-center col-span-4 text-xs mx-auto text-blue h-min ">
              <a-icon type="check" two-tone-color="#65a30d" class="mt-2 px-2" :style="{
                  fontSize: '20px',
                  color: '#65a30d'
                }" />
            </button>
            <button v-else class="flex justify-center col-span-4 text-xs mx-auto text-blue h-min "
              @click="updateCodeSolip(record)">
              <a-icon type="save" theme="twoTone" two-tone-color="#6b7280" class="mt-2 px-2" :style="{
                  fontSize: '20px',
                  color: '#65a30d'
                }" />
            </button>
          </div>
          <div slot="actions" class="title-size font-bold text-gray-500">
            Acciones
          </div>

          <div slot="actions" slot-scope="text, record">
            <button class="flex justify-center text-xs mx-auto text-blue h-min" @click="solicitudeDetail($event, record)">
              <a-icon type="eye" theme="twoTone" two-tone-color="#3366cc" :style="{
                fontSize: '20px',
              }" />
              <b class="my-auto ml-2">Ver</b>
            </button>
            <!-- Arriba : grid text-left text-xs text-blue h-min ml-1 mr-4
            <vue-excel-xlsx :loading="loadingReport" :dataSheets="[solicitudeInfo]" :sheetNames="['Reporte']" book
              :transpose="[false, true]" :columnsSheets="[columnsExcel]" :file-name="'solicitude_' + record.code">
              <button class="flex justify-center text-xs mx-auto text-blue h-min mx-2"
                @click="getSolicitudeInfo($event, record)">
                <a-icon type="download" two-tone-color="#3366cc" :style="{
                  fontSize: '20px',
                }" />
              </button>
            </vue-excel-xlsx>
            -->
          </div>
        </a-table>
        <div class="p-4 flex justify-end">
          <a-pagination v-model="page" :page-size="pageSize" :page-size-options="pageSizeOptions" :total="count"
            show-size-changer size="large" @showSizeChange="onShowSizeChange" />
        </div>
      </div>
      <div>
        <a-modal v-model:visible="modal2Visible" centered>
          <template slot="title">
            <p class="text-xl text-gray-500 font-bold">Cargar archivo de SOLIP</p>
          </template>
          <div class="flex items-center">
            <img ref="gifImage" :src="gifSrc" alt="Loading"
              class="w-6 h-6 mr-1 rounded-full cursor-pointer" @click="getSolipFileTemplate"/>
            <span class="text-base hover:bg-blue-50 cursor-pointer" @click="getSolipFileTemplate">Descargar plantilla</span>
          </div>
          <p class="text-sm text-left text-red-400 mt-4" v-html="feedbackSendFileSOLIP"></p>
          <DragDrop id="attachment" :disabled="files.length > 0" @files-handler="setFiles" :fileList="files"
            label="Carga el documento generado en SOLIP para actualizar el estado de las solicitudes"
            buttonLabel="ADJUNTAR NUEVOS SOPORTES" />
          <template slot="footer">
            <div class="flex flex-col justify-center items-center rounded-full gap-4 max-w-xl py-4">
              <a-button :disabled="!files.length" type="primary" html-type="submit" shape="round" :block="true"
                :loading="loading" class="m-0 p-0" @click="sendFileSOLIP">
                SUBIR ARCHIVO
              </a-button>
              <a-button type="danger" shape="round" :block="true" ghost="" @click="modal2Visible = false" class="mx-2 p-0">
                CANCELAR
              </a-button>
            </div>
          </template>
        </a-modal>
      </div>
      <div v-if="loading" class="absolute w-full justify-center mt-7">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 64px" spin />
        </a-spin>
      </div>
    </div>
  </a-spin>
</template>

<script>
// #004884
import checkFileSize from "@/utils/checkFileSize";
import DynamicForm from "@/components/DynamicForm/";
import TotalComplaints from "@/components/Dashboard/Complaints/TotalComplaints.vue";
import F from '../../../../../public/img/icons/wired-outline-56-document (1).gif'
const columns = [
  {
    slots: { title: "name" },
    dataIndex: "name",
    key: "name",
    width: 90,
  },
  {
    slots: { title: "entity" },
    dataIndex: "entity",
    key: "entity",
    width: 90,
  },
  {
    slots: { title: "solicitude" },
    dataIndex: "solicitude",
    key: "solicitude",
    width: 70,
  },
  {
    slots: { title: "status" },
    dataIndex: "status",
    key: "status",
    width: 60,
    scopedSlots: { customRender: 'status' },
  },
  {
    slots: { title: "code" },
    dataIndex: "code",
    key: "code",
    width: 80,
  },
  {
    slots: { title: "codeSOLIP" },
    dataIndex: "codeSOLIP",
    key: "codeSOLIP",
    width: 120,
    scopedSlots: { customRender: 'codeSOLIP' },
  },
  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 50
  },
];
const columnText = {
  name: "Nombre del CF",
  entity: "Entidad",
  solicitude: "Solicitud",
  status: "Estado",
  code: "Código interno",
  codeSOLIP: "Código SOLIP",
}
const columnsExcelBackup = columns.filter(c => c.dataIndex !== "actions").map(c => ({
  label: columnText[c.slots.title],
  field: c.dataIndex
}));

export default {
  components: { DynamicForm, TotalComplaints },
  data() {
    return {
      gifSrc: F,
      files: [],
      loadingReport: false,
      solicitudeInfo: [],
      columnsExcel: columnsExcelBackup,
      modal2Visible: false,
      filterSearch: "",
      feedbackSendFileSOLIP:"",
      step: 1,
      showTab: -1,
      showLimit: false,
      spinner: false,
      initForm: {},
      loading: false,
      totalPages: 1,
      dataRows: [],
      count: 0,
      page: 1,
      pageSize: 100,
      columns: columns,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
    };
  },
  created() {
    this.getData();
  },
  watch: {
    page: function (newVal, oldVal) {
      if (newVal == this.$route.query.page) {
        return;
      } else {
        this.updateRouterQuery();
      }
    },
    pageSize: function (newVal, oldVal) {
      if (newVal == this.$route.query.pageSize) {
        return;
      } else {
        this.$router.replace({
          query: { page: this.page, pageSize: this.pageSize },
        });
      }
    },
    "$route.query.page": function () {
      this.getData();
    },
  },
  methods: {
    async getSolipFileTemplate(){
      this.spinner = true;
      this.loading = true;
      this.feedbackSendFileSOLIP = "";
      let { data, error } = await this.$api.getResource(
        `/queries-servi/file/download_solip_template`
      );
      this.spinner = false;
      if(error){
        this.feedbackSendFileSOLIP = "Parece que algo falló al descargar la plantilla, vuelve a intentarlo más tarde";
      }
      this.loading = false;
      const link = document.createElement('a')

      link.href = data.url
      link.setAttribute('download', 'solip_file')
      document.body.appendChild(link)

      link.click();
    },
    async solicitudeDetail(checked, record) {

    this.$router.push({'name': 'soliditude-detail', params: {id: record.code}})

    },
    getSolicitudeInfo(event, item) {
      this.solicitudeInfo = [];
      this.solicitudeInfo = [{
        name: item.name,
        entity: item.entity,
        code: item.code,
        codeSOLIP: item.codeSOLIP,
        status: item.status,
        solicitude: item.solicitude,
      }]
    },
    onSearch(value) {
      this.filterSearch = value;
      this.getData()
    },
    async getData() {
      this.loading = true;
      let data = {};

      try {
        this.spinner = true;
        const search = this.filterSearch == "" ? "" : `&search=${this.filterSearch}`;
        const urlService1 = `/jurisdiccional-servi/complaint-historical?page=${this.page}&page_size=${this.pageSize}${search}`;
        let { error, data: dataPivot } = await this.$api.getResource(
          urlService1
        );
        this.spinner = false;
        if (error) {
          console.log(error);
          this.dataRows = [];
          this.$notification.error({
            message: "Error",
            description: "Ocurrio un error",
          });
        } else {
          data = dataPivot;
          this.dataRows = data.data.map((item) => {
            return {
              name: item.cf_name,
              entity: item.company_name,
              code: item.document_id,
              codeSOLIP: item.solip_code,
              status: item.status?item.status:'Abierto',
              solicitude: item.application,
              hasSolipCode: item.solip_code == "" || item.solip_code == undefined ? false : true,
              actionPlans: [],
            };
          });
          this.count = data.count;
        }
      } catch (e) {
        this.spinner = false;
        console.log("Err in getData", e);
        this.$notification.error({
          message: "Error",
          description: "Ocurrio un error",
        });
      }

      this.loading = false;
    },
    async updateCodeSolip(record) {
      this.loading = true;
      console.log(record.codeSOLIP)
      if(record.codeSOLIP == null || record.codeSOLIP == ""){
        this.$notification.warning({
          message: "¡UPS!",
          description: "Este campo no puede estar vacío",
        });
        this.loading = false;
        return false;
      }
      let data_req = { 'solip': { 'solip_code': record.codeSOLIP } };
      this.spinner = true;
      let { data, error } = await this.$api.setCodeSOLIP(record.code, data_req);
      this.spinner = false;
      if(error){
        this.$notification.error({
          message: "Error",
          description: "Ocurrio un error",
        });
        this.loading = false;
        return;
      }
      this.$notification.success({
        message: "Notificación",
        description: "El código ha sido actualizado",
      });
      this.loading = false;
      record.hasSolipCode = true;
    },
    async sendFileSOLIP() {
      this.feedbackSendFileSOLIP = "";
      this.loading = true;
      this.spinner = true;
      let { data, error } = await this.$api.setAnexosSOLIP(this.files);
      this.loading = false;
      this.spinner = false;
      if (error) {
        this.feedbackSendFileSOLIP = error.message;
        if(error.errors){
          this.feedbackSendFileSOLIP += '\n';
          error.errors.forEach((error) => {
            let texTito = '';
            if (error.valor) {
              texTito = `- '${error.campo}': ${error.error} con valor '${error.valor}'\n`;
            }
            if (error.numero_registro) {
              texTito = `- Fila '${error.numero_registro}', Columna '${error.campo}': ${error.error}\n`;
            }
            this.feedbackSendFileSOLIP += texTito;
          });
        };
        this.feedbackSendFileSOLIP = this.feedbackSendFileSOLIP.replace(/\n/g, '<br>');
        console.log(error)
        this.$notification.error({
          message: "Error",
          description: "Ocurrio un error",
        });
      }
      if (data) {
        this.$notification.success({
          message: "Notificación",
          description: `Se actualizaron ${data.updated_total} registros correctamente`,
        });

        if(data.failed_records.length > 0){
          this.feedbackSendFileSOLIP = 'Los siguientes registros no se pudieron actualizar, valide la información:';
          data.failed_records.forEach((code) => {
            this.feedbackSendFileSOLIP += `\n- Solicitud remitente: '${code}'`;
          });
        }
        else{
          this.files = [];
          this.modal2Visible = false;
        }
        setTimeout(() => {
          this.getData();
        }, 1000);
      }
    },
    setFiles(files) {
      if(files.length > 1 || this.files.length > 1){
        this.$notification.warning({
          message: "Notificación",
          description: "No se puede subir más de un archivo",
        });
        return;
      }
      
      if (checkFileSize(files, this.allowedFileSize)) {
        this.feedback =
          "Con el archivo que intenta cargar, se supera el peso máximo permitido de los anexos. Valide la información.";
      } else {
        this.files = files.slice(0, 1);
        this.feedback = "";
      }
    },
    updateRouterQuery() {
      this.$router
        .replace({
          query: {
            page: this.page
          },
        })
        .catch((error) => error);
    },
    async onShowSizeChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      await this.getData();
    },
    pagination(newPage) {
      if (newPage > 0 && newPage <= this.totalPages) {
        this.page = newPage;
      }
      this.getData();
    },
    currentDate() {
      // Obtener la fecha actual
      const today = new Date();

      // Obtener los componentes de la fecha
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Los meses van de 0 a 11, por lo que se suma 1
      const day = String(today.getDate()).padStart(2, "0");

      // Crear la cadena en el formato deseado
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const files = event.target.files;

      if (files.length > 5) {
        alert("Selecciona máximo 5 archivos.");
        return;
      }

      this.files = files;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (file.size > 1024 * 1024) {
          alert(
            "El archivo " +
            file.name +
            " excede el tamaño máximo permitido (1 MB)."
          );
          return;
        }

        console.log("Archivo seleccionado:", file);
      }
    },
    changeShowTab(index) {
      if (this.showTab === index) {
        this.showTab = -1;
      } else {
        this.showTab = index;
      }
    },

    saveRecommendation() {
      this.step = 1;
    },
    changeReports(addReport = true, index) {
      if (addReport) {
        this.newRecommendation.reports.push({});
      } else {
        let arrayPivot = [...this.newRecommendation.reports];
        arrayPivot.splice(index, 1);
        this.newRecommendation.reports = arrayPivot;
      }
    },
    changeStep(step = 1) {
      this.step = step;
    },
    saveTemporaly() {
      this.msgButtonTemp = "Guardado!";
      setTimeout(() => {
        this.visibleButtonSaveTemp = false;
      }, 2000);
      localStorage.setItem(
        "newRecommendationFormSave",
        JSON.stringify(this.dataForm)
      );
    },
    formatStatus(status, defaultClass) {
      const obj = {
        Borrador: "btn-warning-light",
        Formulado: "btn-success-light",
        Finalizado: "btn-success",
        Cerrado: "btn-danger-light",
        Seguimiento: "btn-primary-light",
      };
      return obj[status] + " " + defaultClass;
    },
    formatDate(inputDate) {
      // Convierte la cadena de entrada en un objeto Date
      const date = new Date(inputDate);

      // Obtiene los componentes de la fecha
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Añade cero al principio si es necesario
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      // Calcula la hora en formato 12 horas
      const formattedHours = hours % 12 || 12;

      // Formatea la fecha en el formato deseado en inglés
      const formattedDate = `${month}/${day}/${year} ${formattedHours}:${minutes} ${ampm}`;

      return formattedDate;
    },
  },
};
</script>

<style scoped>
.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}
.accordion-100>div {
  width: 100%;
}

.selection-padding-10>div>div>div,
.selection-padding-10>div>input {
  padding: 10px !important;
  min-height: 52px;
}

button {
  border-radius: 5px;
}

.flex-wrap {
  flex-wrap: wrap;
}

.p-10 {
  padding: 10px;
}

.d-flex {
  display: flex;
}

.flex-center {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.ms-auto {
  margin-left: auto;
}

.text-primary {
  color: #4558dc;
}

.btn-large {
  min-width: 300px;
}

.btn-small {
  min-width: 90px;
  padding: 3px;
}

.btn-white {
  box-shadow: 0 0 2mm #e7e7e7;
}

.btn-square {
  width: 40px;
  height: 40px;
}

.btn-square-small {
  width: 26px;
  height: 26px;
}

.rounded {
  border-radius: 50px;
}

div>small {
  color: #7a7a7a
}

.rounded-border {
  cursor: pointer;
  display: flex;
  padding-top: 2px;
  padding-left: 7px;
  border-radius: 50px;
  height: 26px;
  width: 26px;
  border: 0.5px solid transparent;
  margin: 0px;
  margin-right: 8px;
}

.rounded-border:hover {
  transition: 0.5s;
  color: #4558dc;
}

.rounded-border-active {
  border: 0.5px solid #4558dc;
}

.btn-gray {
  background: #e7e7e7;
  color: black;
}

.btn-primary {
  background: #4558dc;
  color: white;
}

.btn-warning {
  background: #f8b446;
  color: white;
}

.btn-danger {
  background: #ea4a76;
  color: white;
}

.btn-success {
  background: #14a171;
  color: white;
}

.btn-warning-light {
  background: #fff3e0;
  color: #f8b446;
}

.btn-danger-light {
  background: #ffedf2;
  color: #ea4a76;
}

.btn-primary-light {
  background: #edf3ff;
  color: #4558dc;
}

.btn-success-light {
  background: #e5fbf5;
  color: #14a171;
}

.no-border {
  border: 0px !important;
}

.border-bottom-gray {
  border-bottom: 1px solid #e7e7e7;
}

.search-complaints .ant-table-thead>tr>th {
  text-align: center;
}

.flag {
  min-width: 90px;
  display: flex;
  padding: 5px;
  border-radius: 5px;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.search>input {
  border: 1px solid;
  border-radius: 10px;
  min-width: 400px;
  margin-right: 10px;
  padding: 0px 10px;
}

.search>button {
  border-radius: 10px;
}

.table {
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  flex-wrap: wrap;
}

.tableHeader {
  padding: 10px 0;
  background: #fafafa;
  font-weight: bold;
}

.tableHeader>div>h3 {
  color: #6b6b6b !important;
}

.table>div {
  flex-wrap: wrap;
}

.table>div>div {
  border-bottom: 1px solid #e7e7e7;
  padding: 10px 1px;
}

.progressbar {
  height: 26px;
  border-radius: 5px;
  background: #e5fbf5;
  display: flex;
  justify-content: start;
  align-content: center;
  align-items: center;
}

.progressbar>div {
  height: 26px;
  color: white;
  border-radius: 5px;
  background: #14a171;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.w-100 {
  width: 100%;
}

.w-90 {
  width: 90%;
}

.w-80 {
  width: 80%;
}

.w-70 {
  width: 70%;
}

.w-60 {
  width: 60%;
}

.w-50 {
  width: 50%;
}

.w-45 {
  width: 45%;
}

.w-40 {
  width: 40%;
}

.w-35 {
  width: 35%;
}

.w-30 {
  width: 30%;
}

.w-25 {
  width: 25%;
}

.w-20 {
  width: 20%;
}

.w-15 {
  width: 15%;
}

.w-10 {
  width: 10%;
}

.w-5 {
  width: 5%;
}

.d-none {
  display: none;
}

.containerFileOptional {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed gray;
  padding: 20px;
  border-radius: 15px;
}

.containerFileOptional div {
  border-radius: 15px;
  background: rgba(51, 102, 204, var(--tw-bg-opacity));
  margin-bottom: 10px;
  color: white;
  padding: 0.5em 4em;
}

.btn-save-temporaly {
  position: fixed;
  right: 40px;
  top: 200px;
  z-index: 10000;
}

.cursor {
  cursor: pointer;
}

.contentDropdown {
  position: absolute;
  background: white;
  bottom: 20px;
  border: 1px solid #e7e7e7;
  width: 57px;
}

.contentDropdown>div {
  width: 100% !important;
}
</style>